import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box, Flex,
    Select,
    SkeletonText,
    Text, 
    Card, 
    Button,
    CloseButton,
    CardBody
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { useGetPagesQuery } from 'store/BmAccounts/bmAccountApi';

function FaceBookPageSelector({ adsAccount, pageIdToSend, onSelectedPage, selectedPageId, objective = '', destinationType = '' }) {

    const { account_id, name } = adsAccount || {};
    const [selectedPage, setselectedPage] = useState(selectedPageId || '');
    const userInfo = useSelector((state) => state.auth?.userInfo);
    const [showCard, setShowCard] = useState(true);

    const { data: facebookPages = [], isLoading: isFbPageLoading } = useGetPagesQuery(
        { search: '',  },
    );

    useEffect(() => {
        setselectedPage(selectedPageId || '');
    }, [selectedPageId]);


    const handleEventPageChange = (event) => {
        const pageId = event.target.value;
        setselectedPage(pageId);
        onSelectedPage(pageId, account_id);
    };

    const isDisableStatic = (pageIdToSend === selectedPageId && pageIdToSend !== '' && selectedPageId !== '');

    return (
        <Box>
            <Flex gap={'20px'}>
                <Box flex={1}>
                    <Text fontWeight={'bold'} fontSize={'12px'}>{name}</Text>
                    <Text fontSize={'12px'}>{account_id}</Text>
                </Box>

                <Box flex={1}>
                    {isFbPageLoading ? (
                        <Flex justifyContent={'center'} alignItems={'center'}>
                            <SkeletonText width="80%" noOfLines={2} skeletonHeight={2} />
                        </Flex>
                    ) : (
                        <Select
                            placeholder="Facebook page"
                            value={selectedPage}
                            onChange={handleEventPageChange}
                            borderRadius={'md'}
                            size={'sm'}
                            isDisabled={userInfo?.role !== 'client' || isDisableStatic}
                        >
                            {facebookPages?.map((page) => (
                                <option key={page?.id} value={page?.id}>
                                    {page?.name}
                                </option>
                            ))}
                        </Select>
                    )}
                </Box>
            </Flex>
            {selectedPage && objective === 'OUTCOME_LEADS' && destinationType === 'WEBSITE_AND_LEAD_FORM' && (
                (() => {
                const selectedPageObj = facebookPages.find(p => p.id === selectedPage);
                if (selectedPageObj && selectedPageObj.leadgen_tos_accepted === false) {
                    return (
                        <Flex direction={'column'} gap={2} pt={2}>
                        <Text color="red.500" fontSize="12px">
                            Terms of Service Not Accepted: You can't run lead ads until your Facebook Page accepts Facebook's Lead Generation Terms of Service.
                        </Text>
                    
                        {/* Only show card if showCard is true */}
                        {showCard && (
                            <Card bg="#fff" borderRadius="5px" p={2} borderLeft="4px solid gray" position="relative">
                                <CloseButton
                                    position="absolute"
                                    top="6px"
                                    right="6px"
                                    size="sm"
                                    onClick={() => setShowCard(false)}
                                />
                                <CardBody display="flex" alignItems="center" gap={2} p={0} pr={3} >
                                    {/* Icon, vertically centered */}
                                    <Box mt="2px">
                                        <HiOutlineOfficeBuilding color="gray" />
                                    </Box>

                                    {/* Text and Button in a column */}
                                    <Box>
                                        <Text fontSize="12px" mb={3}>
                                            Please read and accept Meta's Lead Ads Terms before creating your ad.
                                        </Text>
                                        <Button
                                            as="a"
                                            href={`https://www.facebook.com/ads/leadgen/tos/?page_id=${selectedPage}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            variant="outline"
                                            colorScheme="gray"
                                            size="sm"
                                            bg="transparent"
                                        >
                                        View terms
                                        </Button>
                                    </Box>
                                </CardBody>
                            </Card>
                        )}
                        </Flex>
                    );
                }
                
                return null;
                })()
            )}
            {isDisableStatic && (
                <Card>
                    <Flex gap={2} p={3}>
                        <InfoOutlineIcon />
                            <Text fontSize="12px">
                            Select a Page at the ad set level
                            For campaigns that use the objective, you must select a Page to represent your business at the ad set level. The same Page will automatically be selected for your ad.
                        </Text>
                    </Flex>
                </Card>
            )}
        </Box>
    )
}

export default FaceBookPageSelector;
